/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { routes as SDKROUTES } from 'app/core/constants/constants';
@Injectable({
    providedIn: 'root'
})
export class ZuperSdkRouteService {

    private _sdkRoutes = SDKROUTES;

    constructor(private _router: Router) { }

    navigateToRoute(data): void {
        const routeData = data.params['page.navigate'][0];
        if (routeData.module) {
            const module = routeData.module.toLowerCase();
            const moduleRoutes = this._sdkRoutes[module.toUpperCase()];
            const routes = moduleRoutes[routeData.page || module.toLowerCase()];
            if (routes) {
                const statePayload = routeData.params;
                const queryParams = routeData.query_params || {};
                let path = `/${this._convertModulePath(routeData.module).toLowerCase()}` + routes.path;
                if (path.includes(`:${module}_uid`)) {
                    path = path.replace(`:${module}_uid`, statePayload[`${module}_uid`]);
                }
                if (statePayload) {
                    const [urlPath, serializedPayload] = this._serializeDataBasedOnModule(module.toUpperCase(), path, statePayload);
                    if (urlPath && serializedPayload) {
                        this._router.navigate([urlPath], {...serializedPayload, queryParams: queryParams});
                    }
                } else {
                    this._router.navigate([path], {queryParams: queryParams});
                }
            }
        }
    }

    private _convertModulePath(module): string {
        switch (module) {
            case 'PROPERTY': return module;
            case 'ASSET': return 'asset_management';
            case 'CALENDAR': return module;
            case 'DISPATCH_BOARD': return module;
            default: return module.toLowerCase() + 's';
        }
    }

    private _serializeDataBasedOnModule(module: string, path: string, payload: any): any {
        switch (module) {
            case 'INVOICE':
            case 'ESTIMATE':
                return [path, {
                    state: {
                        'action': payload.action,
                        'redirect': { ...payload, module: module }
                    }
                }];
            case 'PROJECT':{
                    const key = Object.keys(payload).find(i => i.includes('_uid'));
                    if (key) {
                        const [redirectedModule] = key.split('_uid');
                        path = `${path}?module=${redirectedModule.toUpperCase()}&uid=${payload[key]}`;
                    }
                    return [path, {}];
            }
            case 'PROPERTY':
            case 'ASSET': {
                const key = Object.keys(payload).find(i => i.includes('_uid'));
                if (key) {
                    const [redirectedModule] = key.split('_uid');
                    return [path, {
                        state:
                        {
                            redirect: {
                                module: redirectedModule.toUpperCase(),
                                uid: payload[key]
                            }
                        }
                    }];
                }
                return [path, {}];
            }
            default:
                return [path, { state: { ...payload, module: module } }];
        }
    }
}
